//@ts-check
import styled from 'styled-components';
import { Flex, DarkBlueWrapper } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { ProcessingInProgress } from './sections';
import { LBButton } from '@linearb/buzz';

const ProcessingBox = styled(DarkBlueWrapper)`
  border-radius: 0.45rem;
  width: 100%;
`;

const ProcessingBar = ({
  processingText,
  isProcessing,
  onCloseClick,
  sections = []
}) => {
  return (
    <ProcessingBox>
      <Flex
        data-cy='processing-bar'
        grow='1'
        items='center'
        justify={isProcessing ? 'normal' : 'center'}
      >
        <ProcessingInProgress
          isProcessing={isProcessing}
          processingText={processingText}
        />
        {sections}
      </Flex>
      {onCloseClick && (
        <div className='mr-2'>
          <LBButton onClick={onCloseClick} size='icon' variant='link'>
            <Icon name='close' />
          </LBButton>
        </div>
      )}
    </ProcessingBox>
  );
};

export default ProcessingBar;
